export const AccessCodeService = {

  APPLICATION               : ["APPLICATION"],
  APP_ALL                   : ["APPLICATION","ALL"],

  LOAN                      : ["LOAN"],
  LOAN_DETAIL               : ["LOAN","LOAN-DETAIL"],
  
  LEADS                     : ["LEADS"],
  LEADS_VIEW_LIST           : ["LEADS","ALL"],

};

    
  /*
  constructor(private canAccessPipe: CanAccessPipe) {
  }

  hasAccess(name: string) {
    return this.canAccessPipe.transform(this[name]||[]);
  }
  
  */
